<header class="shadow bg-secondary">
  <div class="container py-3">
      <div class="row">

        <div class="col-4 d-block d-lg-none">
              <div class="row">
                  <div class="col-12 d-flex justify-content-start">

                      <!-- <a class="btn btn-link text-decoration-none text-primary d-flex align-items-center">
                          <i class="material-icons">phone</i>
                      </a> -->

                      <a
                        (click)="slideMenuService.showed = !slideMenuService.showed" 
                        class="btn btn-link text-decoration-none text-white d-flex align-items-center justify-content-center bg-primary rounded-circle p-2">
                          <i class="material-icons">menu</i>
                      </a>

                  </div>
              </div>
          </div>
  
          <div class="col-4 col-lg-2 d-flex align-items-center">
              <a routerLink="/" class="me-3">
                  <img src="./assets/media/logoMaltia.png" width="100%" class="d-none d-lg-block" alt="maltia-logo-blue">
              </a>

              <a routerLink="/">
                  <img src="./assets/media/logoZorro.png" width="90%" class="d-none d-lg-block" alt="maltia-logo-blue">
              </a>

              <a routerLink="/" class="me-3">
                  <img src="./assets/media/logoMaltia.png" width="100%" class="d-block d-lg-none" alt="maltia-logo-blue">
              </a>

              <a routerLink="/">
                  <img src="./assets/media/logoZorro.png" width="100%" class="d-block d-lg-none" alt="maltia-logo-blue">
              </a>
              
          </div>
  
          <div class="col-10 d-none d-lg-block">
              <div class="row">
                  <div class="col-12 d-flex justify-content-end">

                    <ng-template
                      ngFor 
                      let-menuItem 
                      [ngForOf]="menuData">
                      <app-menu-item
                          [colorClass]="color"
                          [menuItem]="menuItem">
                      </app-menu-item>
                    </ng-template>
  
                  </div>
              </div>
          </div>

          <div class="col-4 d-block d-lg-none">
              <div class="row">
                  
              </div>
          </div>

      </div>
  </div>
</header>